/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useCallback, useEffect, useMemo, useState } from 'react';
import retry from 'retry';
import errcode from 'err-code';

const hasOwn = Object.prototype.hasOwnProperty;

const isRetryError = (err: any) =>
    err && err.code === 'EPROMISERETRY' && hasOwn.call(err, 'retried');

// call / cancel / reset

export type UseTimeoutFnReturn = [
    (
        fn: (arg0: (err: any) => never, arg1: any) => any,
        index: number
    ) => Promise<any>,
    (index: number) => void,
    (index: number) => void,
    (index: number) => number
];

export const usePromiseRetry = (
    callerStop: () => void,
    callerReset: () => void,
    options: retry.OperationOptions | undefined
): UseTimeoutFnReturn => {
    const [operations, setOperation] = useState<Array<retry.RetryOperation>>(
        []
    );
    const [isStop, setStop] = useState<boolean>(false);
    const [isReset, setReset] = useState<boolean>(false);

    const callerOpt = useMemo(() => isStop || isReset, [isStop, isReset]);

    const getOperationAttemps = useCallback(
        (index: number) => {
            if (operations) {
                const ops = operations.at(index);
                if (ops) return ops?.attempts();
            }
            return 0;
        },
        [operations]
    );

    const handleOperationStop = useCallback(
        (index: number) => {
            setStop(true);
            const operation = operations.at(index);
            if (operation) {
                operation.stop();
            }

            if (typeof callerStop === 'function') {
                callerStop();
            }
        },
        [callerStop, operations]
    );

    const handleOperationReset = useCallback(
        (index: number) => {
            setReset(true);
            const operation = operations.at(index);
            if (operation) {
                operation.reset();
            }

            if (typeof callerReset === 'function') {
                callerReset();
            }
        },
        [callerReset, operations]
    );
    useEffect(() => {
        if (callerOpt) {
            if (isStop) {
                setStop(false);
            }
            if (isReset) {
                setReset(false);
            }
        }
    }, [callerOpt, isReset, isStop, operations]);

    const initCallback = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (fn: (arg0: (err: any) => never, arg1: any) => any, index: number) =>
            new Promise((resolve, reject) => {
                // eslint-disable-next-line no-underscore-dangle
                const _operation = retry.operation(options);
                setOperation((val) => {
                    const arrOpt = val;
                    arrOpt[index] = _operation;
                    return arrOpt;
                });
                _operation.attempt((number: any) => {
                    Promise.resolve()
                        .then(() =>
                            fn((err: { retried: any }) => {
                                if (isRetryError(err)) {
                                    err = err.retried;
                                }

                                throw errcode(
                                    new Error('Retrying'),
                                    'EPROMISERETRY',
                                    {
                                        retried: err,
                                    }
                                );
                            }, number)
                        )
                        .then(resolve, (err) => {
                            if (isRetryError(err)) {
                                err = err.retried;

                                if (_operation.retry(err || new Error())) {
                                    return;
                                }
                            }

                            reject(err);
                        });
                });
            }),
        [options]
    );

    return [
        initCallback,
        handleOperationReset,
        handleOperationStop,
        getOperationAttemps,
    ];
};
